import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Cliente, ClienteLista } from '../interface/cliente';
import { UtilService } from './util';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  url = `${environment.urlApiProtheus}/wsrcliente`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ) {
  }


  getCliente(CCODIGOLOJA: string, modelo: string = 'B'): Observable<Cliente> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<Cliente>(`${this.url}/${CCODIGOLOJA}/${modelo}`,httpOptions);
  }

  getClienteRecno(NA1RECNO: string, modelo: string = 'B'): Observable<Cliente> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<Cliente>(`${this.url}/recno/${NA1RECNO}/${modelo}`,httpOptions);
  }

  getClienteLista(filtro: {}): Observable<ClienteLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<ClienteLista>(`${this.url}`,httpOptions);
  }

  postCliente(cliente: Cliente) {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post(`${this.url}`, cliente, httpOptions);
  }

}
